import { getRangeFromValues } from ".";

export default function getRangeFromCategory(category) {
    const allValues = Object.values(category).flatMap((item) => item.values);
    return getRangeFromValues(allValues);
}